import { SharedMapService } from './../../_services/map.service';
import { LegendsConfig, LegendService } from './../../_services/legend.service';
import { Component, OnInit, OnDestroy, Input, CUSTOM_ELEMENTS_SCHEMA, NgModule, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { Login, Farm, User, eUserRole } from '../../_models/index';
import { FarmServices, AuthenticationService, GoogleAnalyticsService, FarmerPrevisService, EventEmitterService, EventActionModalLegend, PrecizionServices, ModalService, HandleService } from '../../_services/index';
import { itemValue, menuItem, menuType } from '../../modules/jarvis-ui/_models';
import { JarvisUiService } from '../../modules/jarvis-ui/jarvis-ui.service';
import { Router } from '@angular/router';
import { LoadingService } from '../../framework/auth/components/loading/loading.service';
import { isNullOrUndefined } from '../../_helpers';
import { farmerPrevisSaveChangeResume, farmerPrevisSaveChangesResume } from '../../_models/farmerPrevis/farmerPrevisSaveChangesResume';
import { environment } from '../../../environments/environment';
import { ExportwindowComponent } from '../components/exportwindow/exportwindow.component';
import { localStorageService } from '../../_services/local-storage.service';



@Component({
    selector: 'smag-dashboard',
    styleUrls: ['./dashboard.component.scss', './dashboard.component.responsive.scss'],
    templateUrl: './dashboard.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
//
// @NgModule({
//     schemas: [ CUSTOM_ELEMENTS_SCHEMA ]
// })

export class DashboardComponent implements OnInit, OnDestroy {

    @ViewChild(ExportwindowComponent)
    private exportWindowCmp!: ExportwindowComponent;

    //menu properties for app-jarvis-ui
    public menus: menuItem[] = [];
    public imageUrl = "assets/monbeapi.png";
    public imageConsole = "icon-tractor";
    public imagePDF = "icon-note";

    // devices account parametres url component
    public devicesUrl = environment.Devices.jsUrl;

    private menukey_farm = "farm";

    /**le nombre max d exploitation selectionnable */
    private menu_farms_max_selection= 5;
    private menukey_campaign = "campaign";
    private menukey_cultivation = "cultivation";
    private menukey_action = "action";
    public currentUser: Login | null = null;

    public user: User|null = null;
    /*Ensemble des Cultures sélectionnées par le user MasterPage */
    public SelectedCultivations: menuItem = new menuItem();
    //property for console window is open
    public consoleDialogOpened: boolean = false;
    public cultivationMenu: menuItem = new menuItem();
    //property for export pdf window is open
    public exportDialogOpened: boolean = false;
    //property for devices window is open
    public devicesDialogOpened: boolean = false;
    ///Ensemble des types de prestations
    public exportPrestationTypes: String[] =[];


    // indique que la popin des statuts d export connecté est ouvert
    public popinConnectedStatesOpened: boolean = false;

    public CoopName: string ="";

     //Indique que l'utilisateur est authentifié et peut accéder au dashboard
    //et charge les composant et leurs données
    private _isUserAuthenticated: boolean = false;

    private subsFilteredFarms: any;
    private _shownExploitations: { [userId: string]: Farm[]; } = {};

    /**id de la derniere demande de modif de previs */
    private _lastIdPrevisChangeProgress: number|null = null;

    public get shownExploitations(): { [userId: string]: Farm[]; } {
        if (this._shownExploitations == null)
            this._shownExploitations = {}

        return this._shownExploitations;
    }
    public set shownExploitations(value: { [userId: string]: Farm[]; }) {
        this._shownExploitations = value;
    }


    public get currentFarms(): Farm[] | null {
        if (this.shownExploitations == null || this.GetCurrentUserId() == '') {
            return null;
        }

        return this.shownExploitations[this.GetCurrentUserId()] ?? null;
    }

    public get currentOrders(): Farm[] {
        return this._farmService.FilteredOrders;
    }

    /**Liste des modes d'impression des preconisations*/
    public get ModPrecosTypes(): any[] {
        return this._legendService.ModPrecosTypes;
    }

    /**Liste des modes d'impression inter mode preco*/
    public get IntersModePrecoTypes(): any[] {
        return this._legendService.IntersModePreco;
    }
    /** retourne liste des PDF Diagnostic (Annuels- Pilot LAI) */
    public get DiagnosticPrestTypes(): any[] {
        return this._legendService.DiagnosticPrestTypes;
    }

    /**Liste des modes d'impression supplémentaire formatés en fin de liste*/
    public get ExtraPrintPdfModels(): any[] {
        return this._legendService.ExtrasPrintsModels;
    }

    /**Liste des modes d'impression supplémentaire présenté avant les preconisations */
    public get PrevPrecoPrinPdfModels(): any[] {
        return this._legendService.PrevPrecoPrinPdfModels;
    }

    //Indique que l'utilisateur est authentifié et peut accéder au dashboard
    //et charge les composant et leurs données
    public get isUserAuthenticated(): boolean {
        return this._isUserAuthenticated == true;
    };

    //les code de chargement selon les données
    private CodeLoadingDatas ={
        FarmsFilter: 'Farms',
        Orders: 'Orders',
        CultivationsFilter: 'Cultivations',
        CampaignsFilter: 'Campaigns'
    }

    constructor(private _farmService: FarmServices, private _jarvisMenuService: JarvisUiService,
        private _authService: AuthenticationService,
        private router: Router,
        private _loadingService: LoadingService,
        private _legendService: LegendService,
        private _mapService: SharedMapService,
        private googleService: GoogleAnalyticsService,
        private _farmerPreviService: FarmerPrevisService,
        private _eventEmitterService: EventEmitterService,
        private _precizionServices: PrecizionServices,
        private _modaleService : ModalService
    ) {
        this.menus = this._jarvisMenuService.Menus
    }

    ngOnDestroy(): void {
        this._jarvisMenuService.Clear();
        this.shownExploitations = {};
        this.exportPrestationTypes = [];
    }


    ngOnInit(): void {

        this.InitEventSubscriptions();
        this.CleanSelectedCulturals();
        this.ShowLoaderWaiting()
        this.currentUser = localStorageService.GetJsonCurrentUserBrut();

        this.shownExploitations = localStorageService.GetJsonUserFarms();

        const farmMenu: menuItem = this._jarvisMenuService.AddMenu(this.menukey_farm, 'Exploitations', menuType.MultiSelectable);
        if(this.menu_farms_max_selection>0){
            farmMenu.SetMaxSelectable(this.menu_farms_max_selection, this.menu_farms_max_selection-1, this.menu_farms_max_selection + " exploitations peuvent être sélectionnées au maximum");
        }
        const campaignMenu: menuItem = this._jarvisMenuService.AddMenu(this.menukey_campaign, 'Campagnes', menuType.Mono);
        this.cultivationMenu = this._jarvisMenuService.AddMenu(this.menukey_cultivation, 'Cultures', menuType.MultiSelectable);
        const actionMenu: menuItem = this._jarvisMenuService.AddMenu(this.menukey_action, 'Export', menuType.Action);
        this._jarvisMenuService.AddItem(this.menukey_action, null, "", "PDF", "PDF", false, this.imagePDF, "PDF");
        this._jarvisMenuService.AddItem(this.menukey_action, null, "", "CONSOLE", "Console", false, this.imageConsole, "Modulation");
        this.InitilizeUserDatas(this._authService.AreTokensExpired() == false, false)

    }

     /**
     * Initializes all event subscriptions for the dashboard component.
     */
    private InitEventSubscriptions(): void {
        // Initialize all necessary subscriptions here
        //modale export
           this._eventEmitterService.onCloseExportDialog().subscribe(() => {
            this.exportWindowCmp?.close();
            this.consoleDialogOpened = false;
            this.popinConnectedStatesOpened = false;
        });
        //refresh authentification
        this._authService.onRefreshAfterReAuthenticated.subscribe(refreshed => {
            if (refreshed == true) {
                this.AfterRefreshToken();
            }
        });
    }

    /**
     * Initialize user data
     * @param _iIsAuthenticated indicates if the user is authenticated
     * @param _iForceRefresh forces a refresh of the user data if true
     */
    private InitilizeUserDatas(_iIsAuthenticated:boolean, _iForceRefresh:boolean) {

        if(!_iIsAuthenticated){
            return;
        }
        this._farmService.getuserinfo().subscribe((user: User) => {
            this.user = user;

            this.googleService.InitService(this.user);
        },
            error => {

                this.ShowInfoError(true,'Erreur sur le chargement informations utilisateur.');
            })

        this.UpdateUserAuthenticationStatus();

        let farmers: Farm[]|null = this.currentFarms;

          if(_iForceRefresh == true){

            farmers = null;

        }
        if (farmers == null) {

            this._farmService.getFarms(true).subscribe(farmers => {

                this.Initialize(farmers);
                this.LogOnAnalytics();
                if (isNullOrUndefined(farmers) || farmers.length == 0) {
                    this.NoOrderLoaded();
                    this.HidLoader();

                }
            },
                error => {

                    this.ShowInfoError(true,'Erreur durant le chargement des exploitations.',true);
                    this.NoOrderLoaded(true);
                })
                ;

        }
        else {
            this.Initialize(farmers);
            //Rafraichissement de fond pour les exploitations :

            this._farmService.getFarms(true).subscribe(_farms => {

                let newFarmsId = (_farms.map(({ IdExploitation }) => Number(IdExploitation)).sort((n1, n2) => n1 - n2));
                let oldFarmsId = (farmers.map(({ IdExploitation }) => Number(IdExploitation)).sort((n1, n2) => n1 - n2));

                let equalsId: boolean = JSON.stringify(newFarmsId) === JSON.stringify(oldFarmsId);

                if (!equalsId) {
                    this.Initialize(_farms);
                    this._loadingService.show('Une mise à jour des exploitations est en cours ...');
                }
            },
                error => {

                    this.ShowInfoError(true,'Erreur durant le chargement des exploitations.',true);

                },
                () => {
                    this.HidLoader();
                }
            );
        }
        this.HidLoader();

    }

    /**
     * Initializes the dashboard component with the provided list of farms.
     * @param farmers The list of farms to initialize in the dashboard component.
     * @returns void
     */
    private Initialize(farmers: Farm[]|null) {

        this.ShowLoaderWaiting();
 		/*Nombre Max d exploitations pré selectionnable */
        let _maxFarmPreSelected: number = this.GetNumberFarmsPreselected(farmers ?? []);
        this.CleanSelectedCulturals();
        var farmMenu: menuItem = this._jarvisMenuService.Menus[0];
        if (!farmers) {
            this.HidLoader();
            return;
        }
        this.ClearMenuItems(this.menukey_farm);
        this.ClearMenuItems(this.menukey_campaign);
        farmers.forEach(farmElement => {
            if (farmMenu.GroupItems.filter(g => g.Id == farmElement.CoopSiretNumber).length == 0)
                this._jarvisMenuService.AddGroup(this.menukey_farm, farmElement.CoopSiretNumber, farmElement.CoopName);
        });
        let _CntPreselected = 0;
        farmers.forEach(farmElement => {
            let _blPreselectable = farmElement.CoopSiretNumber == farmMenu.GroupItems[0].Id;
            if (_blPreselectable) {
                _CntPreselected += 1;
                if (_CntPreselected > _maxFarmPreSelected)
                    _blPreselectable = false;
            }
            this._jarvisMenuService.AddItem(this.menukey_farm, farmElement, farmElement.CoopSiretNumber, farmElement.IdExploitation, farmElement.NameExploitation, _blPreselectable);
        });
        this._jarvisMenuService.Order(this.menukey_farm);
        var exploitationSelected = this.GetSelectedFarmIds();


        if(exploitationSelected?.length){



        this._farmService.getCampagnes(exploitationSelected).subscribe(campagnes => {
            campagnes.forEach((campaign, index) => {
                this._jarvisMenuService.AddItem(this.menukey_campaign, campaign, "", campaign.toString(), campaign.toString(), index == 0);
            });
            this._jarvisMenuService.Order(this.menukey_campaign);
            if (this._jarvisMenuService.getSelectedItems(this.menukey_campaign).length > 0) {
                this._farmService.GetFarmByCultivationsFiltered(exploitationSelected, Number(this._jarvisMenuService.getSelectedItems(this.menukey_campaign)[0].Id), null).subscribe(farm => {

                    this.shownExploitations[this.GetCurrentUserId()] = farm;
                    if (farm && farm.length)
                        this.BindingLogoCoopName(farm[0].CoopName);

                },
                    error => {

                         this.ShowLoadingFarmsError(error, exploitationSelected?.length ?? 0, true);

                         })
            }


            this.ReloadFieldCultivation(exploitationSelected, this.GetSelectedCampagne() ?? -1);
            this.AfterChangingMenus();
        },
            error => {
                 this.ShowInfoError(true,'Erreur durant le chargement des campagnes.',true);
                }
            , () => {

                this.HidLoader();
            }
        )
    }else{
        this.HidLoader();
    }

    }


    private GetNumberFarmsPreselected(farms: Farm[]): number {
        let preselected = 0;
        //Ne pas sélectionner d'exploitation si le nombre d'exploitation est important (>5)
        if (this.user != null && farms && farms.length > 0) {
            if (this.user.hasRole(eUserRole.AGRICULTEUR)) {
                preselected = 3;
            }
        }
        return preselected;
    }

    //Dialog Event Region
    /**
     * Fermeture fenetre export pdf
     * @param closed
     */
    public ExportDialogClosed(closed: boolean) {

        this.exportDialogOpened = closed;
    }

    /**
  * Fermeture fenetre export console
  * @param closed
  */
    public ConsoleDialogClosed(closed: boolean) {
        this.consoleDialogOpened = closed;
    }

    /**
  * Fermeture fenetre  parametres consoles utilisateur
  * @param closed
  */
    public DevicesDialogClosed(closed: boolean) {
        this.devicesDialogOpened = closed;
        if (closed === false) {
            this._precizionServices.refreshUserDevices();
        }
    }


    //Clic bouton fenetres parametres consoles utilisateur
    public onDevicesClick(): void {
        this.devicesDialogOpened = true;
        this.popinConnectedStatesOpened = false;
        this.exportWindowCmp?.close();
        this.consoleDialogOpened = false;
    }

    /**
    * Event depuis la popin export console
    * @param event
    */
    public onEventOnExportPopin(event: any) {
        if (event && event.Model == "OPEN_POPIN_CONNECTED_STATES") {
            this.onIconConnectedStatsClick();
        }
    }


    /*Clic Export CONSOLE ou PDF */
    public ActionClick(itemAction: itemValue) {
        if (this.IsFarmSelected()) {
            if(this.devicesDialogOpened == true){
                 this._precizionServices.refreshUserDevices();
            }
            this.devicesDialogOpened = false;

            if (itemAction.Id === "CONSOLE") {
                this.consoleDialogOpened = true;

                if (this.popinConnectedStatesOpened) {
                    //si l export est ouvert on le ferme
                    this.popinConnectedStatesOpened = false;
                }
            }

            else if (itemAction.Id === "PDF") {
                this.exportDialogOpened = true;

                this.exportPrestationTypes = [];
                if (this.currentOrders != null && this.currentOrders.length > 0) {     //On envoi les PrestationsTypes Distinct des Orders donc filtrera choix au client
                    this.currentOrders.forEach(fFarm => {
                        let filterPrestaExport = fFarm.PrestationType;
                        if (fFarm.PresTypeGRCETA() && fFarm.PrestaTypeDatas != null) {
                            //en GRCETA on prend celui ci ainsi il export aussi les diagnostic présent
                            filterPrestaExport = fFarm.PrestaTypeDatas;
                        }
                        if (filterPrestaExport != null && this.exportPrestationTypes.indexOf(filterPrestaExport.toUpperCase()) == -1 && fFarm.IsDiagPilotSPLAI() == false) { this.exportPrestationTypes.push(filterPrestaExport.toUpperCase()) }
                    });
                }
            }
        }
    }

    /**Clic sur autrer interaction (Open popin states) */
    public onOtherActionClick(action: itemValue) {

        if (action && action.Model == "OpenConnectedStatesPopin") {
            if (this.popinConnectedStatesOpened == null) {
                this.popinConnectedStatesOpened = true;
            } else {
                this.popinConnectedStatesOpened = !this.popinConnectedStatesOpened;
            }

        }

    }


    public SelectionChanged(menuChanged: menuItem) {

        this.CleanSelectedCulturals();
        if (menuChanged.Code == this.menukey_farm) {
            this.RefreshLogoCoopName();
            var millisecondsToWait = 1000;
            // @ts-ignore
            setTimeout(this.refreshCulturesByFarms(), millisecondsToWait);


        }
        else if (menuChanged.Code == this.menukey_campaign) {

            this.refreshCulturesByFarmsAndCampagne()
        }
        else if (menuChanged.Code == this.menukey_cultivation) {
            this.BindSelectedCulturals();
        }
        if (this.subsFilteredFarms && this.subsFilteredFarms.unsubscribe)
            this.subsFilteredFarms.unsubscribe();

        let blSelectionDone: boolean = true;
        if (this._jarvisMenuService.getSelectedItems(this.menukey_campaign).length == 0 || !this.IsFarmSelected()) {
            //  Error("Veuillez renseigner les champs nécessaire.")
            //  return;

            blSelectionDone = false;
            this._farmService.FilteredOrders = [];

            this.subsFilteredFarms = this._farmService.GetEmptyFarmArray(

            ).subscribe(
                result => {

                    this.shownExploitations[this.GetCurrentUserId()] = result;

                });
        }


        if (blSelectionDone) {
            this.ShowLoaderWaiting([this.CodeLoadingDatas.Orders]);
            let farmIds =this._jarvisMenuService.getSelectedItems(this.menukey_farm).map(({ Id }) => Id)
            this.subsFilteredFarms = this._farmService.GetFarmByCultivationsFiltered(

                farmIds,
                Number(this._jarvisMenuService.getSelectedItems(this.menukey_campaign)[0].Id),
                this._jarvisMenuService.getSelectedModels(this.menukey_cultivation)
            ).subscribe(
                result => {

                    this.shownExploitations[this.GetCurrentUserId()] = result;
                    this.HidLoader(this.CodeLoadingDatas.Orders);
                },
                error => { this.ShowLoadingFarmsError(error, farmIds?.length ?? 0, true);   }
                ,
                () => {
                    this.HidLoader(this.CodeLoadingDatas.Orders);
                }
            );
        }



    }

    // After view init the map target can be set!
    async ngAfterViewInit() {
        this.ShowLoaderWaiting();
    }

    public logout() {
        this._legendService.clean();
        this._mapService.clean();
        this._authService.logout();
        //efface currentUser
        localStorageService.SetCurrentUser(null);
        localStorageService.remove("userInfo");
        this.router.navigateByUrl('/home', { onSameUrlNavigation: 'reload' });
    }

    refreshCulturesByFarms() {


        this.ShowLoaderWaiting([this.CodeLoadingDatas.Orders, this.CodeLoadingDatas.CultivationsFilter, this.CodeLoadingDatas.CampaignsFilter]);

        var exploitationSelected = this.GetSelectedFarmIds();
        this.ClearMenuItems(this.menukey_campaign);
        this.ClearMenuItems(this.menukey_cultivation);


        if ( exploitationSelected != null && exploitationSelected.length > 0) {

            this._farmService.getCampagnes(exploitationSelected).subscribe(campagnes => {
                campagnes.forEach((campaign, index) => {
                    this._jarvisMenuService.AddItem(this.menukey_campaign, campaign, "", campaign.toString(), campaign.toString(), index == 0)
                })

                let campaignSelected = this.GetSelectedCampagne() ?? 0;
                let FarmIds =this._jarvisMenuService.getSelectedItems(this.menukey_farm).map(({ Id }) => Id);
                this.ReloadFieldCultivation(exploitationSelected, campaignSelected, this.CodeLoadingDatas.CultivationsFilter);
                this.subsFilteredFarms = this._farmService.GetFarmByCultivationsFiltered(
                    FarmIds,
                    campaignSelected,
                    this._jarvisMenuService.getSelectedModels(this.menukey_cultivation)
                ).subscribe(
                    result => {
                        this.shownExploitations[this.GetCurrentUserId()] = result;

                    }
                    ,
                    error => {
                       this.ShowLoadingFarmsError(error, FarmIds?.length ?? 0, true);
                    },
                    () => {
                        this.HidLoader(this.CodeLoadingDatas.Orders);
                    }
                )

                    ;
                this._jarvisMenuService.Order(this.menukey_campaign);
                this.AfterChangingMenus();
            },
                error => {
                    this.ShowInfoError(false,'Erreur durant le chargement des campagnes.',true);

                }
                , () => {

                    this.HidLoader(this.CodeLoadingDatas.CampaignsFilter);
                }

            );
        }
        else {
            /*Aucune exploitation selectionnée */
            this.HidLoader(null, true);
        }

    }

    /**
     * Refreshes the list of cultures & orders based on change cultivation filter or campaign selection.
     */
    public refreshCulturesByFarmsAndCampagne() {

        this.ShowLoaderWaiting([this.CodeLoadingDatas.CultivationsFilter, this.CodeLoadingDatas.Orders]);

        var exploitationSelected = this.GetSelectedFarmIds();
        var campagneSelected = this.GetSelectedCampagne();
        this.ReloadFieldCultivation(exploitationSelected, campagneSelected ?? 0,this.CodeLoadingDatas.CultivationsFilter);


        let FarmIds = this._jarvisMenuService.getSelectedItems(this.menukey_farm).map(({ Id }) => Id);
        this.subsFilteredFarms = this._farmService.GetFarmByCultivationsFiltered(
            FarmIds,
            campagneSelected ?? 0,
            this._jarvisMenuService.getSelectedModels(this.menukey_cultivation)
        ).subscribe(
            result => {
                this.shownExploitations[this.GetCurrentUserId()] = result;
            },
            error => {
                 this.ShowLoadingFarmsError(error, FarmIds?.length ?? 0, true);
             },
            () => {
                this.HidLoader(this.CodeLoadingDatas.Orders);
            }
        );
    }

    /**
    *On recharge les Parcelles et Cultures selon les exploitations selectionnées et la campagne
    */
    private ReloadFieldCultivation(_iFarmsSelected: any[], _iCmpSelected: number, _iHidUniqueActionCode?: string) {

        if(_iFarmsSelected.length && _iCmpSelected)
        this._farmService.getCultivations(_iFarmsSelected, _iCmpSelected).subscribe(
            result => {
                this._jarvisMenuService.removeAllItems(this.menukey_cultivation);

                result.forEach(cultivation => {
                    this._jarvisMenuService.AddItem(this.menukey_cultivation, cultivation, "", cultivation.Id.toString(), cultivation.Name);
                })
                this._jarvisMenuService.Order(this.menukey_cultivation);
                this.AfterChangingMenus();
                ;
            }, error => {

                this.ShowInfoError(false,'Erreur durant le chargement des cultures.',true);
             },
            () => {
                this.HidLoader(_iHidUniqueActionCode);
            });
    }

    /**
    *on rempli la liste des cultures sélectionnées par le User pour export console
    */
    private BindSelectedCulturals() {
        this.CleanSelectedCulturals();
        let recs: any[] = this._jarvisMenuService.getSelectedModels(this.menukey_cultivation);
        if (recs.length > 0) {
            this.SelectedCultivations.GroupItems = recs;
        }
    }
    /**
      *Suppression des Cultures User Selectionnnées
      */
    private CleanSelectedCulturals() {
        this.SelectedCultivations = new menuItem();
        this.SelectedCultivations.GroupItems = [];
    }


    /**
     *permet le retrait des éléments des menus
     */
    private ClearMenuItems(menukey: string) {
        this._jarvisMenuService.removeAllItems(menukey);
    }

    /**
      *Indique si des exploitations on été selectionnées par le user
      */
    private IsFarmSelected() {
        var Selected = this.GetSelectedFarmIds();
        return Selected != null && Selected.length > 0;
    }


    /**
    *Retourne la liste des exploitation sélectionnées dans le menu par le user
    */
    private GetSelectedFarmIds(): any[] {
        return this._jarvisMenuService.getSelectedModels(this.menukey_farm).map(({ IdExploitation }) => IdExploitation);
    }
    /**
   *Retourne la campagne selectionnée par le USER
   * NULL si aucune campagne
   */
    private GetSelectedCampagne() {
        if (this._jarvisMenuService.getSelectedItems(this.menukey_campaign).length > 0)
            return Number(this._jarvisMenuService.getSelectedItems(this.menukey_campaign).filter(Checked => Checked.Checked = true)[0].Id);
        return null;
    }

    /**
     * Rafraichissement de Logo CoopName selon selection d exploitation
     */
    private RefreshLogoCoopName() {
        let Coops = this._jarvisMenuService.getSelectedModels(this.menukey_farm).map(({ CoopName }) => CoopName);
        if (Coops && Coops.length > 0 && Coops[0] != null) {
            this.BindingLogoCoopName(Coops[0]);
        } else {
            this.BindingLogoCoopName("");
        }

    }
    /**
     * Remplissage de la coop niveau du logo BANNER
     * @param _CoopName
     */
    private BindingLogoCoopName(_CoopName: string) {
        this.CoopName = _CoopName;
    }

    /**Event sur changement de menu */
    private AfterChangingMenus() {
        this._farmerPreviService.SetIsLastCampaign = this._jarvisMenuService.IsLastRecordSelected(this.menukey_campaign) ?? false;
        //on referme la modale de duplication de préco tech
        this._eventEmitterService.emitCloseDuplicateTechPrecoDialog();
        this._eventEmitterService.emitCloseUpdateFarmerPrevisDialog();
        this.InitFarmPrevisSubscriptions();
    }


    /**
     *  Gestion si aucun order chargé
     * @param blIsException indique qu'une exception au chargement s est produit
     */
    private NoOrderLoaded(blIsException: boolean = false) {

        this._farmService.FilteredOrders = [];
        this._mapService.CleanLegendMap();
        if (blIsException)
            this.Initialize(null);
        if (!blIsException) {

            this.ShowInfoError(false,'Il n\'y a pas de données à afficher pour ce compte.',true);
            this.logout();
        }
        else

            this.ShowInfoError(true,'Une erreur est survenue lors de la récupération des données pour ce compte.',true);
    }


    //#region Gestion des previsionelles

    private InitFarmPrevisSubscriptions() {

        this._eventEmitterService.invokeFarmerPrevisReloadingOrder.subscribe((fSubUpdatePrevis: farmerPrevisSaveChangesResume) => {

            if (fSubUpdatePrevis && this._lastIdPrevisChangeProgress !== fSubUpdatePrevis.UniqueId) {

                //on evite les soucriptions passant x X
                this._lastIdPrevisChangeProgress = fSubUpdatePrevis.UniqueId;
                if (fSubUpdatePrevis.IsDeleteMode()) {
                    this.UpdatePrevisDeleted(fSubUpdatePrevis)
                } else {
                    this.ReloadingOnPrevisChanges(fSubUpdatePrevis)
                }
            }
        },
            error => {

                 this.ShowInfoError(true,'Erreur sur le chargement des previsionelles.',true);
            });
    }

    /**Rechargement des données legend export .. apres modif de prévis */
    private ReloadingOnPrevisChanges(fSubUpdatePrevis: farmerPrevisSaveChangesResume) {

        let farmChangedIds = fSubUpdatePrevis.FarmsIds.map(t => t.toString());
        this.ShowLoaderWaiting();
        this._farmService.GetFarmByCultivationsFiltered(farmChangedIds, Number(this._jarvisMenuService.getSelectedItems(this.menukey_campaign)[0].Id), null, false).subscribe(ordersUpdate => {
            let forceFarmsReload = false;
            //on récupère que pour l'exploitation concerné ses orders sans enregistrer au service l'order
            if (ordersUpdate && ordersUpdate.length) {
                //les orders chargés en interface
                let frontOrders = this._farmService.FilteredOrders;
                if (frontOrders?.length) {

                    fSubUpdatePrevis.OrdersidsChanges.forEach(fUpdOrdId => {
                        let ndxResp = ordersUpdate.findIndex(t => t.OrderUid == fUpdOrdId)
                        let ndxFront = frontOrders.findIndex(t => t.OrderUid == fUpdOrdId)
                        if (ndxResp !== -1 && ndxFront !== -1) {
                            frontOrders[ndxFront] = ordersUpdate[ndxResp];
                        } else {
                            forceFarmsReload = true;
                            console.error('ReloadingOnPrevisChanges response order id not found', fUpdOrdId)
                        }
                    })
                    //les orders chargés mis son remis ce qui provoque le rechargement des données legend carto FRONT
                    this.UpdateFrontDatas(frontOrders);
                } else {
                    forceFarmsReload = true;
                }

                if (forceFarmsReload == true) {
                    this.ReloadingFarmsSelected()
                }
                else {
                    this.HidLoader(null,true);
                }


            } else {
                this.ReloadingFarmsSelected();
            }

        },
            error => {
                this.ShowLoadingFarmsError(error, farmChangedIds?.length ?? 0, false);

                this.HidLoader(null,true);
            })
    }

    /**Rechargement de l'interface depuis les exploitations selectionnées pour la campagne et les cultures selectionnées */
    private ReloadingFarmsSelected() {
        this.ShowLoaderWaiting([this.CodeLoadingDatas.Orders]);
        this._farmService.GetFarmByCultivationsFiltered(this._farmService.FilteredFarmsIds(), Number(this._jarvisMenuService.getSelectedItems(this.menukey_campaign)[0].Id), this._jarvisMenuService.getSelectedModels(this.menukey_cultivation), true).subscribe(ordersUpdate => {
            this.HidLoader(this.CodeLoadingDatas.Orders,true);
        },
            error => {
                this.ShowLoadingFarmsError(error, this._farmService.FilteredFarmsIds()?.length ?? 0, true);

              this.HidLoader(this.CodeLoadingDatas.Orders,true);
            })
    }

    /**
     * Suppression depuis l'order selectionné
     * @param fSubUpdatePrevis
     */
    private UpdatePrevisDeleted(fSubUpdatePrevis: farmerPrevisSaveChangesResume) {

        let forceReloading = false;
        //les orders chargés en interface
        let frontOrders = this._farmService.FilteredOrders;
        if (frontOrders?.length) {
            this.ShowLoaderWaiting();
            //on supprime direct dans l'order les previs parcelle avec le status suppression
            fSubUpdatePrevis.OrdersidsChanges.forEach((fordId: string) => {
                let ndxOrd = frontOrders.findIndex(x => x.OrderUid == fordId);
                if (ndxOrd !== -1) {
                    let forderupdt = frontOrders[ndxOrd];
                    let plotPrevisDeleted = fSubUpdatePrevis.Changes.filter(r => r.MatchOnDeleting() && r.OrderId == fordId);

                    if (plotPrevisDeleted.length > 0) {
                        plotPrevisDeleted.forEach((fPrevis: farmerPrevisSaveChangeResume) => {
                            let ndxSector = forderupdt.Sectors.findIndex(f => f.Id == fPrevis.SectorId);
                            if (ndxSector == -1) {
                                forceReloading = true;
                                return;
                            } else {
                                let fSector = forderupdt.Sectors[ndxSector];
                                let ndxPlot = fSector.CultivationPlots.findIndex(t => t.Id == fPrevis.PlotId);
                                if (ndxPlot == -1) {
                                    forceReloading = true;
                                    return;
                                } else {
                                    let fPlot = fSector.CultivationPlots[ndxPlot];
                                    if (fPlot.InterPrevis?.length) {
                                        let ndxPrevis = fPlot.InterPrevis.findIndex(t => t !== undefined && t.IdIntervention == fPrevis.InterId);
                                        if (ndxPrevis == -1) {
                                            forceReloading = true;
                                            return;
                                        } else {
                                            let previs = fPlot.InterPrevis[ndxPrevis];
                                            let previsIdent = previs.Ident;
                                            if (previsIdent == 0) {
                                                forceReloading = true;
                                                return;
                                            }

                                            fPlot.MicroPlots.forEach((fMicro => {
                                                if (fMicro.InterPrevis && fMicro.InterPrevis.findIndex(mc => mc.Ident == previsIdent) != -1) {
                                                    fMicro.InterPrevis.splice(fMicro.InterPrevis.findIndex(mc => mc.Ident == previsIdent), 1);

                                                }
                                            }))

                                            //suppression
                                            fPlot.InterPrevis.splice(ndxPrevis, 1);
                                        }

                                        fSector.CultivationPlots[ndxPlot] = fPlot;
                                    }
                                }
                                forderupdt.Sectors[ndxSector] = fSector;
                            }

                        })
                    }

                    frontOrders[ndxOrd] = forderupdt;
                    this._farmService.FilteredOrders

                } else {
                    forceReloading = true;
                    return;
                }

            }

            )
        } else {
            forceReloading = true;
        }

        if (forceReloading == true) {
            //il y eu soucis donc on recharge depuis le back
            this.ReloadingOnPrevisChanges(fSubUpdatePrevis);
        } else {
            //ca provoque le rechargememnt des legendes..
            this.UpdateFrontDatas(frontOrders);
            this.HidLoader();

        }
    }

    /**On provoque le rechargement des legendes et données  order utilisateurs */
    private UpdateFrontDatas(_iFrontOrders: Farm[]) {
        this._farmService.ReloadFrontOrdersDatas([]);
        setTimeout(() => {
            this._farmService.ReloadFrontOrdersDatas(_iFrontOrders);

        }, 500);
        ;
    }

    //fermeture de la modale de duplication de préconisation technicien via la croix
    public onDuplicateTechPrecoDialogClosed(event: any) {
        this._eventEmitterService.emitCloseDuplicateTechPrecoDialog();
    }

    //fermeture de la modale de modification farmer prévis via la croix
    public onFarmerPrevisUpdateDialogClosed(event: any) {
        this._eventEmitterService.emitCloseUpdateFarmerPrevisDialog();
    }

    // Event fermeture de la popin des statuts d export connecté
    public popinConnectedStatesClosed(event: any) {
        this.popinConnectedStatesOpened = false;
    }


    /**sur click icon popin des statut d export connectés */
    public onIconConnectedStatsClick() {
        this.popinConnectedStatesOpened = true;
    }


    //#endregion

    /**Maj du statut d'authentification de l'utilisateur permettant le chargmeent des composant avec tokens */
    private UpdateUserAuthenticationStatus() {
        this._isUserAuthenticated = !this._authService.AreTokensExpired();
    }

    /**Déclenché suite au rafraichissement des tokens après réauthentification */
    private AfterRefreshToken() {
       this.UpdateUserAuthenticationStatus();
        this.InitilizeUserDatas(this._authService.AreTokensExpired() == false, true);
    }


    private LogOnAnalytics() {
        this.googleService.eventScreenViewEmitter('DashBoard')
    }

    /**
     * Affichage loader
     * @param _iHidUniqueActionCodes tableau des codes d'action uniques pour lesquels afficher le loader
     */
    ShowLoaderWaiting(_iHidUniqueActionCodes:string[]|null = null) {
        if(_iHidUniqueActionCodes){
            this._loadingService.show("Merci de patienter");
            this._loadingService.addCodes(_iHidUniqueActionCodes);
        }else{
            this._loadingService.show("Merci de patienter");
        }
    }

    /**
     * Masquage loader
     * @param _iHidUniqueActionCode code d'action unique pour lequel masquer le loader
     * @param _ClearAllActions true pour supprimer tous les codes d'action actifs et fermer le loader
     */
    HidLoader(_iHidUniqueActionCode:string|null = null, _ClearAllActions:boolean=false) {
        if(!_iHidUniqueActionCode){
            this._loadingService.hide();
        }else{
            this._loadingService.hideByCode(_iHidUniqueActionCode);
        }
        if(_ClearAllActions){
            this._loadingService.clearAllCodes();
        }

    }

    /**
     * Affiche un message d'erreur lors du chargement des exploitations. en echec
     * @param error erreur API
     * @param _iNumberFarms nombre d'exploitations concernées ( si >3 message de reduire la sélection)
     * @param isByFilters true si l'erreur survient lors du filtrage par campagne - cultures, false chargment complet des exploitations
     */
    private ShowLoadingFarmsError(error:any,_iNumberFarms :number, isByFilters: boolean) {
            // Implementation for showing error messages
            let userMessage = isByFilters ? `Erreur durant le chargement des exploitations selon campagne - cultures,` : `Erreur durant le chargement des exploitations,`;

                userMessage += ` veuillez réessayer dans quelques instants.`;

            if(_iNumberFarms >3){
                userMessage += ` Sinon, réduisez le nombre d'exploitations sélectionnées.`;
            }
            this.ShowInfoError(false,userMessage,true);
    }

    /**
     * visualise une modale en erreur avec un message sans confirmation
     * @param _iOnlyIfAuthenticated true: contrôle qu'il soit authentifié avant d'afficher le message d'erreur(si non le message n'est pas affiché)
     * @param _iUserText texte affiché
     * @param _iStopLoader true on stop le loader
     * @param _iTitle titre affiché défaut :'Erreur'
     */
  private ShowInfoError(_iOnlyIfAuthenticated:boolean, _iUserText: string, _iStopLoader:boolean=false, _iTitle: string = 'Erreur') {

     if(_iStopLoader == true){
        this.HidLoader(null,true);
    }
    if(_iOnlyIfAuthenticated && !this.isUserAuthenticated){
        return;
    }
    this._modaleService.Error(_iTitle, _iUserText);
  }

  /**
   *
   * @returns string identifiant de l'utilisateur courant sinon ''
   */
  private GetCurrentUserId():string{
    return this?.currentUser?.userid.toString() ?? '';
  }
}
